'use client';

import Cookies from 'js-cookie';
import { useEffect } from 'react';

import { setCookie } from '@/helpers/common';
import { COOKIE_NAME } from '@/helpers/cookie';
import { useGetCommonStore } from '@/store';

const COOKIE_EXPIRES = 365 * 10; // 10 years

export const useAuthCookies = () => {
  const useCommonStore = useGetCommonStore();

  const isAuthenticated = useCommonStore.use.isAuthenticated();
  const pendingUser = useCommonStore.use.pendingUser();

  useEffect(() => {
    if (isAuthenticated) {
      setCookie(COOKIE_NAME.IS_REGISTERED, 'true', COOKIE_EXPIRES);
      setCookie(COOKIE_NAME.ACTIVE_SESSION, 'true', COOKIE_EXPIRES);
    } else {
      setCookie(COOKIE_NAME.ACTIVE_SESSION, 'false', COOKIE_EXPIRES);
    }
  }, [isAuthenticated]);

  useEffect(() => {
    if (pendingUser) return;
    if (isAuthenticated) {
      useCommonStore.setState({ isAuthenticatedByCookie: true });
      Cookies.set(COOKIE_NAME.IS_AUTHENTICATED, 'true', {
        sameSite: 'lax',
        secure: true,
      });
    } else {
      useCommonStore.setState({ isAuthenticatedByCookie: false });
      Cookies.set(COOKIE_NAME.IS_AUTHENTICATED, 'false', {
        sameSite: 'lax',
        secure: true,
      });
    }
  }, [isAuthenticated, pendingUser]);
};
